export interface MatrixAlgorithm {
    id: number;
    name: string;
}

export const QLC_MATRIX_ALGORITHMS: MatrixAlgorithm[] = [
    { id: 0, name: 'Plain Color' },
    { id: 1, name: 'Text' },
    { id: 2, name: 'Image' },
    { id: 3, name: 'Audio Spectrum' },
    { id: 4, name: '3D Starfield' },
    { id: 5, name: 'Alternate' },
    { id: 6, name: 'Aurora' },
    { id: 7, name: 'Balls' },
    { id: 8, name: 'Blinder' },
    { id: 9, name: 'Circles' },
    { id: 10, name: 'Circular' },
    { id: 11, name: 'Confetti' },
    { id: 12, name: 'ConnectDots' },
    { id: 13, name: 'Even/Odd' },
    { id: 14, name: 'Eyes' },
    { id: 15, name: 'Fill' },
    { id: 16, name: 'Fill From Center' },
    { id: 17, name: 'Fill Unfill' },
    { id: 18, name: 'Fill Unfill From Center' },
    { id: 19, name: 'Fill Unfill Squares From Center' },
    { id: 20, name: 'Fire' },
    { id: 21, name: 'Fire Flicker' },
    { id: 22, name: 'Fireflies' },
    { id: 23, name: 'Fireworks' },
    { id: 24, name: 'Flying Objects' },
    { id: 25, name: 'Fractal' },
    { id: 26, name: 'Gradient' },
    { id: 27, name: 'Juggle' },
    { id: 28, name: 'Lantern' },
    { id: 29, name: 'Lightning' },
    { id: 30, name: 'Lines' },
    { id: 31, name: 'Marquee' },
    { id: 32, name: 'Meteor' },
    { id: 33, name: 'Noise' },
    { id: 34, name: 'One By One' },
    { id: 35, name: 'Opposite' },
    { id: 36, name: 'OrthoLines' },
    { id: 37, name: 'Pacifica' },
    { id: 38, name: 'Plasma' },
    { id: 39, name: 'Random Column' },
    { id: 40, name: 'Random Fill Column' },
    { id: 41, name: 'Random Fill Row' },
    { id: 42, name: 'Random Fill Single' },
    { id: 43, name: 'Random Pixel Per Row' },
    { id: 44, name: 'Random Pixel Per Row Multicolor' },
    { id: 45, name: 'Random Row' },
    { id: 46, name: 'Random Single' },
    { id: 47, name: 'Ripple' },
    { id: 48, name: 'Shapes' },
    { id: 49, name: 'Sine Wave' },
    { id: 50, name: 'Sinelon' },
    { id: 51, name: 'Snow or Bubbles' },
    { id: 52, name: 'Spark' },
    { id: 53, name: 'Squares' },
    { id: 54, name: 'Squares From Center' },
    { id: 55, name: 'Stage Pulse' },
    { id: 56, name: 'Stripes' },
    { id: 57, name: 'Stripes From Center' },
    { id: 58, name: 'Strobe' },
    { id: 59, name: 'Strum' },
    { id: 60, name: 'TwinkleFox' },
    { id: 61, name: 'Vertical fall' },
    { id: 62, name: 'Water Flow' },
    { id: 63, name: 'Waves' },
];

export const DEFAULT_ALGORITHM_IDS = [34, 13, 38, 63, 58, 26];

export function getAlgorithmById(id: number): MatrixAlgorithm | undefined {
    return QLC_MATRIX_ALGORITHMS.find(a => a.id === id);
}
